import React from 'react';
import PropTypes from 'prop-types';

import style from './style.module.scss';

export function HeaderBlock(props) {
  return (
    <div
      tabIndex={0}
      className={`${style.heatBlockHeader} ${props.className} `}>
      {props.text}
    </div>
  );
}

HeaderBlock.propTypes = {
  /**
   * classname
   */
  className: PropTypes.string,
  /**
   * text to be displayed in header
   */
  text: PropTypes.string,
};

HeaderBlock.defaultProps = {
  text: 'HEAT BLOCK',
};
